module.exports = __webpack_public_path__ + "static/scale-model-of-abilene-texas-b0c535f2bf20f882e7f87c074f539850.png";